<template>
    <div>
        <v-app-bar
            fixed
            flat
            color="#ececec"
            width="100vw"
            style="z-index: 10000000000000000;"
        >
            <v-btn icon @click.stop="drawer = !drawer" >
                <v-icon color="#1b2f5a">
                    mdi-menu
                </v-icon>
            </v-btn>
            <v-spacer/>
            <img
                width="50px"
                contain
                align-center
                center
                :src="require('@/assets/MEMBERSPARON_LOGO.svg')"
                style="filter: drop-shadow(0 0 10px white); display: block; margin: 0 auto;"
                class="mx-auto"
                @click="$router.push({name: 'Homepage'})"
            />
            <v-spacer></v-spacer>
            <v-btn icon @click="$router.go(-1)">
                <v-icon color="#1b2f5a">keyboard_arrow_left</v-icon>
            </v-btn>
        </v-app-bar>
        <v-navigation-drawer
            v-model="drawer"
            app
            temporary
            disable-resize-watcher
            style="z-index: 10000000000"
            class="my-0"
        >
            <v-btn
                icon
                dark
                @click="drawer = !drawer"
            >
                <v-icon small>mdi-close</v-icon>
            </v-btn>
            <v-list
                nav
                class="text-center"
            >
                <v-list-item-group
                    v-for="(item, index) in menu"
                    :key="index"
                    active-class="text--accent-4"
                >
                    <v-list-item>
                        <v-list-item-title @click = "menuActionClick(item.route)">
                            {{ item.title }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
                <v-list-item-group
                    active-class="text--accent-4"
                >
                    <v-list-item class="justify-center">
                        <a href="tel:+302109852175">
                            <v-icon small height="2px" color="#ad282d" class="pr-2">mdi-phone</v-icon> <span style="font-size: 14px; color: #1b2f5a;">2109852175</span>
                        </a>    
                    </v-list-item>
                    <v-list-item style="font-size: 14px; color: #1b2f5a;" class="justify-center">
                        <a href="mailto:contact@paron-card.gr">
                            <v-icon small height="2px" color="#ad282d" class="pr-2">mdi-email</v-icon> <span style="font-size: 14px; color: #1b2f5a;">contact@paron-card.gr</span>
                        </a>
                    </v-list-item>
                    <v-list-item class="justify-center">
                        <v-btn
                            icon
                            href="https://www.youtube.com/channel/UC4E83cf5r0kA5768eU7ArZQ"
                            target="_blank"
                        >
                            <v-icon color="#1b2f5a">
                                mdi-youtube
                            </v-icon>
                        </v-btn>
                        <v-btn
                            icon
                            href="https://www.facebook.com/profile.php?id=100085421851501"
                            target="_blank"
                            class="mx-3" 
                        >
                            <v-icon color="#1b2f5a">
                                mdi-facebook
                            </v-icon>
                        </v-btn>
                        <v-btn
                            icon
                            href="https://www.instagram.com/paroncard/ "
                            target="_blank"
                        >
                            <v-icon color="#1b2f5a">
                                mdi-instagram
                            </v-icon>
                        </v-btn>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
    export default {
        data: () => ({
            drawer: false,
            menu: [
                {
                    route: 'HomePage', 
                    title: 'Αρχική',
                    entitle: 'Home'
                },
                {
                    route: 'AboutUs', 
                    title: 'PARON CARD',
                    entitle: 'About Us'
                },
                { 
                    route: 'Partners',
                    title: 'Επιχειρήσεις/Εκπτώσεις',
                    entitle: 'Partners'
                }
            ]
        }),
        computed: {
        },
        methods: {
            menuActionClick(route) {
                var newPath = '/'+route;
                if(this.$route.path != newPath){
                    this.$router.push({path: newPath})
                }
            }
        }
    }
</script>

<style>

.v-list-item .v-list-item__title, .v-list-item .v-list-item__subtitle {
    line-height: 3.3 !important;
}

</style>

<style lang="scss" scoped>
.logo-pos{
    position: flex;
  }

  .theme--dark.v-app-bar.v-toolbar.v-sheet {
    // background-color: #ffffffab;
    background-color: transparent;
  }
  .theme--light.v-app-bar.v-toolbar.v-sheet {
    // background-color: #ffffffab;
    background-color: transparent;
  }
  .v-btn--icon.v-size--default .v-icon, .v-btn--fab.v-size--default .v-icon{
    font-size: 35px;
    color: #1b2f5a;
  }

  .sub-menu {
    font-size: 17px;
    color: #1b2f5a !important;
  }

  .v-tab {
    font-weight: bolder;
    font-size: 20px;
  }
  .v-tab:before {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    background-color: transparent;
  }
  .mobile-logo {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
.v-list-item .v-list-item__title, .v-list-item .v-list-item__subtitle {
    line-height: 3.7;
}
.v-list-item__title {
    align-self: center;
    font-size: 2rem;
    line-height: 5.2;
    color: #1b2f5a;
}

.v-navigation-drawer--absolute {
    position: absolute;
}

@media only screen and (max-width: 600px){
    .v-list-item__title {
        font-size: 1.2rem;
        line-height: 4.2;
    }
}

@media only screen and (min-width: 600px){
    .v-list-item__title {
        font-size: 1.75rem;
        line-height: 5.2;
    }
}

    .v-navigation-drawer--absolute {
        width: 100vw!important;
        height: auto;
    }

    a {
        color: #1b2f5a !important; /* blue colors for links too */
        text-decoration: none; /* no underline */
    }
</style>

